export const MIN_PASSWORD_LENGTH = 6
export const ORDERS_LIMIT = 50

// -----------------------------------------------------
//  ENUM node status
// -----------------------------------------------------
export const VISIBILITY_STATUS = Object.freeze({
    HIDDEN: 0,
    VISIBLE: 1,
    ARCHIVED: 2
})

export const STORE_APPROVAL_STATUS = Object.freeze({
    PENDING_APPROVAL: 0,
    APPROVED: 1
})

export const STORE_EMPLOYEE_STATUS = Object.freeze({
    INACTIVE: 'INACTIVE',
    ACTIVE: 'ACTIVE',
    ADMIN: 'ADMIN'
})

export const ORDER_ACTIONS = Object.freeze({
    PENDING: 'PENDING',
    APPROVED: 'APPROVED',
    READY: 'READY',
    PICKED_UP: 'PICKED_UP',
    DELIVERED: 'DELIVERED',
    CANCELED: 'CANCELED'
})

export const PAYMENT_STATUSES = Object.freeze({
    PAYMENT_PROCESSING: 'PAYMENT_PROCESSING',
    PAYMENT_DELAYED: 'PAYMENT_DELAYED',
    ACTION_NEEDED: 'ACTION_NEEDED',
    PAYMENT_COMPLETED: 'PAYMENT_COMPLETED'
})

export const ORDER_MESSAGE_TYPE = Object.freeze({
    ERROR: 'ERROR',
    SUPPORT: 'SUPPORT'
})

export const STORE_TIMEZONE_OPTIONS = [
    {
        value: 'Canada/Newfoundland',
        label: 'Canada/Newfoundland (-3:30)'
    },
    {
        value: 'Canada/Atlantic',
        label: 'Canada/Atlantic (-4:00)'
    },
    {
        value: 'Canada/Eastern',
        label: 'Canada/Eastern (-5:00)'
    },
    {
        value: 'Canada/Central',
        label: 'Canada/Central (-6:00)'
    },
    {
        value: 'Canada/Mountain',
        label: 'Canada/Mountain (-7:00)'
    },
    {
        value: 'Canada/Pacific',
        label: 'Canada/Pacific (-8:00)'
    }
]

export const SORT_DAYS = {
    sunday: 0,
    monday: 1,
    tuesday: 2,
    wednesday: 3,
    thursday: 4,
    friday: 5,
    saturday: 6
}
